import Skeleton from '@/common/components//skeleton';

export function CollectionSkeleton() {
  return (
    <div className="mb-4 flex h-full w-full flex-col gap-y-4">
      <Skeleton type="home-slider" className="!h-[172px] rounded-md" />

      <div className="flex w-full justify-evenly">
        <Skeleton
          type="home-slider"
          className="!h-[120px] rounded-md"
          repeat={4}
        />
      </div>
    </div>
  );
}
